module.exports = ".body-auth{background:#fff;max-width:100%}.body-auth:before{content:' ';display:table}\n"


//////////////////
// WEBPACK FOOTER
// ./src/auth/AppComponent.sass
// module id = 145
// module chunks = 0